// Lazy Firebase app + Auth for the Identity Platform (GCP) auth path.
// Initialized lazily on first use,
// so a build that never signs in does not load or require Firebase config.
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { currentAudience } from '../accessState';
import type { Auth } from 'firebase/auth';
import { config } from '@/shared/config/env';

const authByAudience = new Map<string, Auth>();

export function getFirebaseAuth(): Auth {
  const audience = currentAudience();
  const existing = authByAudience.get(audience);
  if (existing) return existing;
  const { apiKey, authDomain, projectId } = config.firebase;
  if (!apiKey || !authDomain || !projectId) {
    throw new Error(
      'Firebase config missing: set __FIREBASE__ (API_KEY/AUTH_DOMAIN/PROJECT_ID).',
    );
  }
  const app = initializeApp(
    { apiKey, authDomain, projectId },
    audience === 'portal' ? 'biasafe-client-portal' : undefined,
  );
  const auth = getAuth(app);
  authByAudience.set(audience, auth);
  return auth;
}
